<template>
    <span class="icon" v-if="iconValue" v-html="iconValue"></span>
</template>
<script src="./icon.js"></script>
<style src="./icon.scss" lang="scss"></style>
